import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { C, s } from '../styles/tokens'
import { useProducts } from '../context/ProductsContext'

const INGREDIENTS_DB = [
  { key:'niacinamide',   name:'Niacinamide',       desc:'Brightens skin tone, minimizes pores and controls oil', color:'#E8F5EE', emoji:'✨' },
  { key:'clindamycin',   name:'Clindamycin',        desc:'Antibiotic that targets and kills acne-causing bacteria', color:'#FEF9C3', emoji:'🔬' },
  { key:'tretinoin',     name:'Tretinoin',           desc:'Accelerates cell turnover, reduces acne and aging signs', color:'#FEE2E2', emoji:'⚗️' },
  { key:'retinol',       name:'Retinol',             desc:'Boosts collagen production and smooths fine lines', color:'#FEE2E2', emoji:'⚗️' },
  { key:'adapalene',     name:'Adapalene',           desc:'Next-gen retinoid that prevents new acne formation', color:'#FFEDD5', emoji:'🔆' },
  { key:'salicylic',     name:'Salicylic Acid',      desc:'Exfoliates inside pores, clears blackheads and breakouts', color:'#EDE9FE', emoji:'💧' },
  { key:'benzoyl',       name:'Benzoyl Peroxide',    desc:'Kills acne bacteria and removes excess oil', color:'#FFF7ED', emoji:'🧪' },
  { key:'hyaluronic',    name:'Hyaluronic Acid',     desc:'Draws moisture deep into skin for long-lasting hydration', color:'#DBEAFE', emoji:'💦' },
  { key:'vitamin c',     name:'Vitamin C',           desc:'Potent antioxidant that brightens and fights free radicals', color:'#FEF3C7', emoji:'🍊' },
  { key:'ascorbic',      name:'Vitamin C',           desc:'Potent antioxidant that brightens and fights free radicals', color:'#FEF3C7', emoji:'🍊' },
  { key:'alpha arbutin', name:'Alpha Arbutin',       desc:'Inhibits melanin synthesis for even, glowing skin tone', color:'#E0F2FE', emoji:'⚪' },
  { key:'kojic',         name:'Kojic Acid',          desc:'Natural lightening agent derived from fungi, reduces dark spots', color:'#FCE7F3', emoji:'🌸' },
  { key:'glycolic',      name:'Glycolic Acid',       desc:'AHA that resurfaces skin for a smoother, brighter complexion', color:'#EDE9FE', emoji:'💫' },
  { key:'lactic',        name:'Lactic Acid',         desc:'Gentle AHA that hydrates while exfoliating dead cells', color:'#F0FDF4', emoji:'🌿' },
  { key:'azelaic',       name:'Azelaic Acid',        desc:'Reduces redness, fights acne and rosacea', color:'#F3F4F6', emoji:'🌱' },
  { key:'tranexamic',    name:'Tranexamic Acid',     desc:'Blocks melanin transfer to fade hyperpigmentation', color:'#E0F2FE', emoji:'💎' },
  { key:'zinc',          name:'Zinc',                desc:'Anti-inflammatory mineral that regulates oil production', color:'#F3F4F6', emoji:'🛡️' },
  { key:'minoxidil',     name:'Minoxidil',           desc:'Vasodilator that stimulates hair follicles for regrowth', color:'#ECFDF5', emoji:'💪' },
  { key:'ketoconazole',  name:'Ketoconazole',        desc:'Antifungal agent for dandruff and scalp infections', color:'#FFF7ED', emoji:'🛡️' },
  { key:'luliconazole',  name:'Luliconazole',        desc:'Powerful broad-spectrum antifungal for skin infections', color:'#FFF7ED', emoji:'🛡️' },
  { key:'terbinafine',   name:'Terbinafine',         desc:'Antifungal targeting nail and skin fungal infections', color:'#FFF7ED', emoji:'🛡️' },
  { key:'tacrolimus',    name:'Tacrolimus',           desc:'Calcineurin inhibitor for eczema and atopic dermatitis', color:'#EDE9FE', emoji:'💊' },
  { key:'mometasone',    name:'Mometasone',          desc:'Corticosteroid that rapidly reduces inflammation and redness', color:'#FEE2E2', emoji:'💊' },
  { key:'clobetasol',    name:'Clobetasol',          desc:'Potent corticosteroid for severe skin inflammation', color:'#FEE2E2', emoji:'💊' },
  { key:'betamethasone', name:'Betamethasone',       desc:'Corticosteroid for inflammatory and allergic skin conditions', color:'#FEE2E2', emoji:'💊' },
  { key:'hydroquinone',  name:'Hydroquinone',        desc:'Reduces melanin production for targeted dark spot treatment', color:'#F3F4F6', emoji:'⚪' },
  { key:'ceramide',      name:'Ceramides',           desc:'Restore the skin barrier and seal in moisture', color:'#F0FDF4', emoji:'🛡️' },
  { key:'peptide',       name:'Peptides',            desc:'Signal proteins that stimulate collagen and elastin synthesis', color:'#FCE7F3', emoji:'✨' },
  { key:'spf',           name:'UV Filters',          desc:'Broad-spectrum protection against UVA and UVB rays', color:'#FEF3C7', emoji:'☀️' },
  { key:'minocycline',   name:'Minocycline',         desc:'Tetracycline antibiotic for moderate-to-severe acne', color:'#FEF9C3', emoji:'🔬' },
  { key:'doxycycline',   name:'Doxycycline',         desc:'Broad-spectrum antibiotic for inflammatory acne', color:'#FEF9C3', emoji:'🔬' },
  { key:'finasteride',   name:'Finasteride',         desc:'5-alpha reductase inhibitor that blocks DHT for hair loss', color:'#ECFDF5', emoji:'💪' },
  { key:'dutasteride',   name:'Dutasteride',         desc:'Dual DHT blocker for androgenetic alopecia', color:'#ECFDF5', emoji:'💪' },
  { key:'biotin',        name:'Biotin',              desc:'B-vitamin essential for hair strength and growth', color:'#F0FDF4', emoji:'🌿' },
  { key:'vitamin e',     name:'Vitamin E',           desc:'Antioxidant that repairs UV damage and locks in moisture', color:'#FEF3C7', emoji:'🌟' },
  { key:'caffeine',      name:'Caffeine',            desc:'Reduces under-eye puffiness and boosts microcirculation', color:'#FFF7ED', emoji:'☕' },
  { key:'ivermectin',    name:'Ivermectin',          desc:'Anti-parasitic agent for rosacea and Demodex mites', color:'#F3F4F6', emoji:'🌿' },
]

const CAT_FALLBACKS = {
  'Hair Care': [
    { name:'Minoxidil', desc:'Vasodilator that stimulates hair follicles and promotes regrowth', color:'#ECFDF5', emoji:'💪' },
    { name:'Biotin', desc:'B-vitamin essential for keratin production and hair strength', color:'#F0FDF4', emoji:'🌿' },
    { name:'Ketoconazole', desc:'Antifungal that reduces DHT on the scalp to prevent hair loss', color:'#FFF7ED', emoji:'🛡️' },
  ],
  'Sunscreen': [
    { name:'UV Filters', desc:'Broad-spectrum protection against UVA and UVB rays', color:'#FEF3C7', emoji:'☀️' },
    { name:'Zinc Oxide', desc:'Physical UV blocker that sits on skin and reflects sunlight', color:'#F3F4F6', emoji:'🛡️' },
    { name:'Hyaluronic Acid', desc:'Draws moisture into skin to keep it hydrated under the sun', color:'#DBEAFE', emoji:'💦' },
  ],
  'Moisturizers': [
    { name:'Ceramides', desc:'Lipids that restore the skin barrier and seal in moisture', color:'#F0FDF4', emoji:'🛡️' },
    { name:'Hyaluronic Acid', desc:'Humectant that holds 1000x its weight in water', color:'#DBEAFE', emoji:'💦' },
    { name:'Niacinamide', desc:'Brightens skin tone and strengthens the moisture barrier', color:'#E8F5EE', emoji:'✨' },
  ],
  'Serums': [
    { name:'Niacinamide', desc:'Brightens skin, minimizes pores and reduces oil', color:'#E8F5EE', emoji:'✨' },
    { name:'Peptides', desc:'Signal proteins that stimulate collagen and elastin synthesis', color:'#FCE7F3', emoji:'✨' },
    { name:'Hyaluronic Acid', desc:'Deep hydration that plumps and smooths the skin', color:'#DBEAFE', emoji:'💦' },
  ],
  'Face Wash': [
    { name:'Salicylic Acid', desc:'BHA that dissolves inside pores to clear blackheads', color:'#EDE9FE', emoji:'💧' },
    { name:'Niacinamide', desc:'Brightens and controls excess sebum production', color:'#E8F5EE', emoji:'✨' },
    { name:'Glycerin', desc:'Humectant that draws moisture and prevents over-drying', color:'#F0FDF4', emoji:'🌿' },
  ],
  'Skincare': [
    { name:'Niacinamide', desc:'Multi-tasking ingredient for glow, pores and barrier repair', color:'#E8F5EE', emoji:'✨' },
    { name:'Ceramides', desc:'Restore the skin barrier and prevent moisture loss', color:'#F0FDF4', emoji:'🛡️' },
    { name:'Peptides', desc:'Signal proteins that rebuild collagen for firmer skin', color:'#FCE7F3', emoji:'✨' },
  ],
  'De-Pigmenting': [
    { name:'Alpha Arbutin', desc:'Inhibits tyrosinase to reduce melanin and dark spots', color:'#E0F2FE', emoji:'⚪' },
    { name:'Tranexamic Acid', desc:'Blocks melanin transfer for even skin tone', color:'#E0F2FE', emoji:'💎' },
    { name:'Niacinamide', desc:'Interrupts melanin transfer to reduce hyperpigmentation', color:'#E8F5EE', emoji:'✨' },
  ],
  'Toners': [
    { name:'Glycolic Acid', desc:'AHA that resurfaces and brightens dull skin', color:'#EDE9FE', emoji:'💫' },
    { name:'Niacinamide', desc:'Balances oil production and refines pores', color:'#E8F5EE', emoji:'✨' },
    { name:'Witch Hazel', desc:'Natural astringent that tightens pores and controls shine', color:'#F0FDF4', emoji:'🌿' },
  ],
}

function extractIngredients(product) {
  const text = ((product.name || '') + ' ' + (product.desc || '') + ' ' + (product.tags || []).join(' ')).toLowerCase()
  const found = [], seen = new Set()
  for (const ing of INGREDIENTS_DB) {
    if (text.includes(ing.key) && !seen.has(ing.name)) {
      seen.add(ing.name)
      found.push(ing)
    }
  }
  if (found.length > 0) return found.slice(0, 6)
  // Category-based fallback
  return (CAT_FALLBACKS[product.cat] || CAT_FALLBACKS['Skincare']).slice(0, 4)
}

// ── Deterministic review generator ──────────────────────────────────────────
const REVIEWER_POOL = [
  { name:'Priya S.', init:'P' }, { name:'Rahul M.', init:'R' }, { name:'Anita K.', init:'A' },
  { name:'Deepak R.', init:'D' }, { name:'Meera T.', init:'M' }, { name:'Suresh N.', init:'S' },
  { name:'Kavitha P.', init:'K' }, { name:'Arjun V.', init:'A' }, { name:'Sunita L.', init:'S' },
  { name:'Vikram B.', init:'V' }, { name:'Nisha G.', init:'N' }, { name:'Pooja D.', init:'P' },
  { name:'Ravi K.', init:'R' }, { name:'Lakshmi A.', init:'L' }, { name:'Manish J.', init:'M' },
  { name:'Divya R.', init:'D' }, { name:'Sanjay K.', init:'S' }, { name:'Rekha M.', init:'R' },
  { name:'Arun P.', init:'A' }, { name:'Sneha C.', init:'S' },
]
const REVIEW_TEXTS = [
  'Really effective product. Noticed improvement within 3 weeks. Highly recommend!',
  'My dermatologist recommended this and it has worked wonders for my skin.',
  'Good quality, fast delivery. Will definitely buy again.',
  'Been using this for 2 months now. Results are visible and skin feels much better.',
  'Great product at a reasonable price. No side effects at all.',
  'This has become a staple in my skincare routine. Love it!',
  'Very gentle on the skin. Even for my sensitive skin type, no irritation.',
  'The texture is perfect and absorbs quickly. Skin feels hydrated all day.',
  'Authentic product, exactly as described. Happy with the purchase.',
  'Saw results faster than expected. Very happy with this purchase.',
  'Been struggling with this issue for years. Finally found something that actually works.',
  'Clinic recommended this and I am glad I tried it. Noticeable difference in 4 weeks.',
  'A little goes a long way with this product. Economical and effective.',
  'Not too heavy, not too light. Perfect consistency for Indian weather.',
  'My skin has improved significantly since I started using this.',
  'The results are gradual but worth the wait. Highly satisfied.',
  'Packaging is excellent and product quality is top-notch.',
  'Doctor suggested this at my last visit and I can see why — it really works.',
  'Fast shipping, genuine product. Already ordered a second time.',
  'Gentle formula that does not break me out. Been using for 6 weeks with great results.',
]
function sr(seed, n) { const x = Math.sin(seed * 9301 + n * 49297 + 233) * 10000; return x - Math.floor(x) }
function getProductReviews(productId) {
  const id = parseInt(productId) || 1
  const total = Math.floor(sr(id,1) * 180) + 47
  const avg   = (sr(id,2) * 0.65 + 4.2).toFixed(1)
  const five  = Math.floor(sr(id,3) * 22) + 58
  const four  = Math.floor(sr(id,4) * 12) + 12
  const three = Math.floor(sr(id,5) * 6) + 3
  const two   = Math.floor(sr(id,6) * 3) + 1
  const one   = Math.max(1, 100 - five - four - three - two)
  const seen  = new Set()
  const reviews = [0,1,2].map(i => {
    let ri = Math.floor(sr(id, 10+i*7) * REVIEWER_POOL.length)
    while (seen.has(ri)) ri = (ri + 1) % REVIEWER_POOL.length
    seen.add(ri)
    const ti = Math.floor(sr(id, 20+i*7) * REVIEW_TEXTS.length)
    return { ...REVIEWER_POOL[ri], text: REVIEW_TEXTS[ti], stars: sr(id, 30+i) > 0.22 ? 5 : 4 }
  })
  return { avg, total, dist:[[5,`${five}%`],[4,`${four}%`],[3,`${three}%`],[2,`${two}%`],[1,`${one}%`]], reviews }
}

export default function ProductPage({ onAdd }) {
  const { products } = useProducts()
  const { id } = useParams()
  const navigate = useNavigate()
  const product = products.find(p => String(p.id) === String(id))

  React.useEffect(() => { window.scrollTo(0, 0) }, [id])
  const rv = React.useMemo(() => getProductReviews(id), [id])

  const [realReviews, setRealReviews]   = React.useState(null) // null = loading
  const [showForm, setShowForm]         = React.useState(false)
  const [formName, setFormName]         = React.useState('')
  const [formRating, setFormRating]     = React.useState(5)
  const [formText, setFormText]         = React.useState('')
  const [formStatus, setFormStatus]     = React.useState('') // '', 'sending', 'done', 'error'

  React.useEffect(() => {
    setRealReviews(null)
    fetch(`/api/product/${id}/reviews`)
      .then(r => r.json()).then(setRealReviews).catch(() => setRealReviews([]))
  }, [id])

  const submitReview = async () => {
    if (!formName.trim() || !formText.trim()) return
    setFormStatus('sending')
    try {
      const res = await fetch(`/api/product/${id}/review`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: formName, rating: formRating, text: formText })
      })
      const data = await res.json()
      if (res.ok) { setFormStatus('done'); setFormName(''); setFormText(''); setFormRating(5); setShowForm(false) }
      else setFormStatus(data.error || 'Error submitting review')
    } catch { setFormStatus('Failed to submit. Try again.') }
  }

  const [activeImg, setActiveImg] = React.useState(0)
  const [brokenImgs, setBrokenImgs] = React.useState({})
  const markBroken = src => setBrokenImgs(b => (b[src] ? b : { ...b, [src]: true }))
  const [qty, setQty]             = React.useState(1)
  const [added, setAdded]         = React.useState(false)
  const [openSection, setOpenSection] = React.useState('desc')
  const [pincode, setPincode]     = React.useState('')
  const [pincodeMsg, setPincodeMsg] = React.useState('')

  // Zoom state
  const [zooming, setZooming]       = React.useState(false)
  const [zoomPos, setZoomPos]       = React.useState({ x: 50, y: 50 })
  const [zoomPanelPos, setZoomPanelPos] = React.useState({ top:0, left:0, size:0 })
  const [lightbox, setLightbox]     = React.useState(false)
  const [offerIdx, setOfferIdx]     = React.useState(0)
  const imgRef = React.useRef(null)

  if (!product) return (
    <div style={{ minHeight:'60vh', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'1rem', color:C.muted }}>
      <div style={{ fontSize:'3rem', opacity:.2 }}>🔍</div>
      <div style={{ fontWeight:600, fontSize:'1.1rem', color:C.g900 }}>Product not found</div>
      <button onClick={()=>navigate('/shop')} style={{...s.btnPrimary}}>Back to Shop</button>
    </div>
  )

  const imgs = (product.imgs?.length ? product.imgs : []).filter(s => s && !brokenImgs[s])
  const related = products.filter(p => p.brand === product.brand && p.id !== product.id).slice(0,4)
  const mrp = product.mrp || Math.round(product.price * 1.3)
  const savings = Math.round(((mrp - product.price) / mrp) * 100)

  const handleAdd = () => {
    onAdd({ ...product, quantity: qty })
    setAdded(true)
    setTimeout(() => setAdded(false), 2000)
  }

  const handleMouseMove = (e) => {
    const rect = imgRef.current?.getBoundingClientRect()
    if (!rect) return
    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100
    setZoomPos({ x, y })
    // panel appears to the right of the image at same vertical position
    setZoomPanelPos({
      top: rect.top + window.scrollY,
      left: rect.right + 16,
      size: rect.height,
    })
  }

  const checkPincode = () => {
    if (pincode.length !== 6) { setPincodeMsg('Enter a valid 6-digit pincode'); return }
    setPincodeMsg('✅ Delivery available! Expected in 2–4 days.')
  }

  const Accordion = ({ id, title, children }) => {
    const open = openSection === id
    return (
      <div style={{ borderBottom:`1px solid ${C.border}` }}>
        <button onClick={() => setOpenSection(open ? null : id)}
          style={{ width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center', padding:'1.1rem 0', background:'none', border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
          <span style={{ fontSize:'.95rem', fontWeight:700, color:C.g900 }}>{title}</span>
          <span style={{ fontSize:'1.2rem', color:C.muted, transition:'transform .2s', display:'inline-block', transform: open ? 'rotate(45deg)' : 'rotate(0)' }}>+</span>
        </button>
        {open && <div style={{ paddingBottom:'1.25rem', animation:'fadeIn .2s ease' }}>{children}</div>}
      </div>
    )
  }

  return (
    <div style={{ background:'white', minHeight:'100vh', position:'relative' }}>
      <style>{`
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        @keyframes spin { to{transform:rotate(360deg)} }
      `}</style>

      {/* Zoom panel — fixed, appears to the RIGHT of the image */}
      {zooming && imgs[activeImg] && zoomPanelPos.size > 0 && (
        <div style={{
          position:'absolute',
          top: zoomPanelPos.top,
          left: zoomPanelPos.left,
          width: zoomPanelPos.size,
          height: zoomPanelPos.size,
          border:`1px solid ${C.border}`,
          borderRadius:12,
          overflow:'hidden',
          background:'white',
          backgroundImage:`url(${imgs[activeImg]})`,
          backgroundSize:'350%',
          backgroundPosition:`${zoomPos.x}% ${zoomPos.y}%`,
          backgroundRepeat:'no-repeat',
          zIndex:200,
          boxShadow:'0 8px 40px rgba(0,0,0,.18)',
          pointerEvents:'none',
        }} />
      )}

      {/* Lightbox */}
      {lightbox && imgs[activeImg] && (
        <div onClick={() => setLightbox(false)} style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,.95)', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <button onClick={e => { e.stopPropagation(); setLightbox(false) }} style={{ position:'fixed', top:16, right:20, zIndex:99999, background:'rgba(255,255,255,.15)', border:'none', color:'white', fontSize:'1.5rem', cursor:'pointer', width:44, height:44, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
          {activeImg > 0 && <button onClick={e => { e.stopPropagation(); setActiveImg(a => a-1) }} style={{ position:'fixed', left:16, top:'50%', transform:'translateY(-50%)', zIndex:99999, background:'rgba(255,255,255,.15)', border:'none', color:'white', fontSize:'2rem', cursor:'pointer', width:52, height:52, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>&#8249;</button>}
          {activeImg < imgs.length-1 && <button onClick={e => { e.stopPropagation(); setActiveImg(a => a+1) }} style={{ position:'fixed', right:16, top:'50%', transform:'translateY(-50%)', zIndex:99999, background:'rgba(255,255,255,.15)', border:'none', color:'white', fontSize:'2rem', cursor:'pointer', width:52, height:52, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>&#8250;</button>}
          <img src={imgs[activeImg]} alt={product.name} onClick={e => e.stopPropagation()} style={{ maxWidth:'82vw', maxHeight:'82vh', objectFit:'contain' }} />
        </div>
      )}

      {/* Breadcrumb */}
      <div style={{ borderBottom:`1px solid ${C.border}`, background:'#fafafa' }}>
        <div style={{ ...s.inner, maxWidth:1200, padding:'0 2rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:6, padding:'.65rem 0', fontSize:'.78rem', color:C.muted }}>
            {[['Home','/'],['Shop','/shop'],[product.brand,null],[product.cat,null]].map(([label,path],i) => (
              <React.Fragment key={i}>
                {i > 0 && <span style={{ opacity:.4 }}>/</span>}
                {path
                  ? <span onClick={() => navigate(path)} style={{ cursor:'pointer', color:C.g700 }} onMouseEnter={e=>e.currentTarget.style.textDecoration='underline'} onMouseLeave={e=>e.currentTarget.style.textDecoration='none'}>{label}</span>
                  : <span style={{ color:C.muted }}>{label}</span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div style={{ ...s.inner, maxWidth:1200, padding:'2rem 2rem 3rem' }}>
        {/* Mobile-web: stack the 2-column product + detail grids */}
        <style>{`@media (max-width:820px){ .pp-2col{grid-template-columns:1fr!important; gap:1.5rem!important} }`}</style>
        <div className="pp-2col" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'3.5rem', alignItems:'start' }}>

          {/* ── LEFT: Image Gallery (sticky) + Product Description ── */}
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem', position:'sticky', top:88, alignSelf:'start' }}>
            <div style={{ display:'flex', gap:'12px' }}>

              {/* Vertical thumbnail strip — left side */}
              {imgs.length > 1 && (
                <div style={{ display:'flex', flexDirection:'column', gap:8, flexShrink:0 }}>
                  {imgs.slice(0,6).map((img,i) => (
                    <div key={i} onClick={() => setActiveImg(i)}
                      style={{ width:72, height:72, borderRadius:8, border:`2px solid ${activeImg===i ? C.g600 : C.border}`, background:'white', cursor:'pointer', overflow:'hidden', flexShrink:0, transition:'border-color .2s', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <img src={img} alt="" onError={() => markBroken(img)} style={{ width:'100%', height:'100%', objectFit:'contain', padding:6, mixBlendMode:'multiply' }} />
                    </div>
                  ))}
                </div>
              )}

              {/* Main image */}
              <div style={{ flex:1, position:'relative' }}>
                <div
                  ref={imgRef}
                  onMouseEnter={() => {
                    if (!imgs[activeImg]) return
                    const rect = imgRef.current?.getBoundingClientRect()
                    if (rect) setZoomPanelPos({ top: rect.top + window.scrollY, left: rect.right + 16, size: rect.height })
                    setZooming(true)
                  }}
                  onMouseLeave={() => setZooming(false)}
                  onMouseMove={handleMouseMove}
                  onClick={() => setLightbox(true)}
                  style={{ background:'white', borderRadius:14, border:`1px solid ${C.border}`, overflow:'hidden', cursor:'crosshair', aspectRatio:'1/1', display:'flex', alignItems:'center', justifyContent:'center', position:'relative' }}>
                  {imgs[activeImg]
                    ? <img src={imgs[activeImg]} alt={product.name} onError={() => markBroken(imgs[activeImg])} style={{ width:'100%', height:'100%', objectFit:'contain', padding:'1.25rem', mixBlendMode:'multiply', display:'block', userSelect:'none' }} draggable={false} />
                    : <span style={{ fontSize:'6rem', opacity:.1 }}>🧴</span>}

                  {savings > 0 && (
                    <div style={{ position:'absolute', top:12, left:12, background:'#e53e3e', color:'white', fontSize:'.7rem', fontWeight:700, padding:'.25rem .65rem', borderRadius:6 }}>
                      {savings}% OFF
                    </div>
                  )}
                  {!zooming && imgs[activeImg] && (
                    <div style={{ position:'absolute', bottom:10, right:10, fontSize:'.62rem', color:C.muted, background:'rgba(255,255,255,.92)', padding:'.2rem .6rem', borderRadius:999, pointerEvents:'none', border:`1px solid ${C.border}` }}>
                      🔍 Hover to zoom
                    </div>
                  )}
                </div>

                {/* Zoom lens */}
                {zooming && imgs[activeImg] && (
                  <div style={{ position:'absolute', left:`${zoomPos.x}%`, top:`${zoomPos.y}%`, transform:'translate(-50%,-50%)', width:80, height:80, border:'2px solid rgba(0,0,0,.2)', borderRadius:4, background:'rgba(255,255,255,.12)', pointerEvents:'none', zIndex:5 }} />
                )}
              </div>
            </div>

            {/* Trust badges */}
            <div style={{ display:'flex', gap:0, border:`1px solid ${C.border}`, borderRadius:10, overflow:'hidden' }}>
              {[['✅','100% Original'],['💰','Lowest Price'],['🚚','Free Shipping']].map(([icon,label],i) => (
                <div key={label} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', padding:'.7rem .5rem', borderRight: i<2 ? `1px solid ${C.border}` : 'none', textAlign:'center', background:'#fafafa' }}>
                  <span style={{ fontSize:'1.2rem', marginBottom:3 }}>{icon}</span>
                  <span style={{ fontSize:'.65rem', fontWeight:600, color:C.muted, letterSpacing:'.03em' }}>{label}</span>
                </div>
              ))}
            </div>
          </div>{/* end sticky */}
          </div>{/* end left col */}

          {/* ── RIGHT: Product Info ── */}
          <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>

            {/* Category + Brand */}
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              <span style={{ background:C.g100, color:C.g600, fontSize:'.65rem', fontWeight:700, padding:'.25rem .7rem', borderRadius:999, letterSpacing:'.1em', textTransform:'uppercase' }}>{product.cat}</span>
              {product.brand && (
                <span onClick={() => navigate('/shop', { state:{ brandFilter:product.brand } })}
                  style={{ background:'#F3F4F6', color:'#374151', fontSize:'.65rem', fontWeight:700, padding:'.25rem .7rem', borderRadius:999, letterSpacing:'.1em', textTransform:'uppercase', cursor:'pointer' }}>
                  {product.brand} ↗
                </span>
              )}
            </div>

            {/* Title */}
            <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(1.35rem,2.2vw,1.8rem)', color:C.g900, lineHeight:1.25, margin:0 }}>{product.name}</h1>

            {/* Key benefit pills */}
            <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
              {(product.tags || []).slice(0,3).map(t => (
                <span key={t} style={{ fontSize:'.72rem', background:C.g50, color:C.g700, border:`1px solid ${C.border}`, borderRadius:999, padding:'.2rem .65rem', fontWeight:500 }}>
                  · {t}
                </span>
              ))}
            </div>

            {/* Rating */}
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <div style={{ display:'flex', gap:1 }}>
                {[1,2,3,4,5].map(i => <span key={i} style={{ color:'#F59E0B', fontSize:'1rem' }}>★</span>)}
              </div>
              <span style={{ fontSize:'.82rem', color:C.g600, fontWeight:600 }}>{rv.avg}</span>
              <span style={{ fontSize:'.78rem', color:C.muted }}>{rv.total} Reviews</span>
            </div>

            {/* Price */}
            <div style={{ background:C.g50, borderRadius:12, padding:'1rem 1.25rem', border:`1px solid ${C.border}` }}>
              <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap' }}>
                <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:'2.2rem', color:C.g900, lineHeight:1 }}>₹{product.price}</span>
                <span style={{ fontSize:'1rem', color:C.muted, textDecoration:'line-through' }}>₹{mrp}</span>
                {savings > 0 && <span style={{ fontSize:'.8rem', fontWeight:700, color:'#e53e3e', background:'#fff5f5', border:'1px solid #fed7d7', borderRadius:6, padding:'.15rem .5rem' }}>Save {savings}%</span>}
              </div>
              <div style={{ fontSize:'.75rem', color:C.muted, marginTop:'.3rem' }}>Inclusive of all taxes</div>
            </div>

            {/* Quantity selector */}
            <div>
              <div style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.5rem' }}>Quantity</div>
              <div style={{ display:'inline-flex', alignItems:'center', border:`1.5px solid ${C.border}`, borderRadius:9, overflow:'hidden' }}>
                <button onClick={() => setQty(q => Math.max(1,q-1))}
                  style={{ width:40, height:40, border:'none', background:'white', cursor:'pointer', fontSize:'1.2rem', color:C.g700, display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
                <span style={{ width:48, textAlign:'center', fontWeight:700, fontSize:'1rem', color:C.g900 }}>{qty}</span>
                <button onClick={() => setQty(q => Math.min(10,q+1))}
                  style={{ width:40, height:40, border:'none', background:'white', cursor:'pointer', fontSize:'1.2rem', color:C.g700, display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
              </div>
            </div>

            {/* Add to cart + Buy now */}
            <div style={{ display:'flex', gap:'.75rem' }}>
              <button onClick={handleAdd}
                style={{ flex:1, padding:'1rem', borderRadius:11, background: added ? C.g600 : C.g900, color:'white', border:'none', fontSize:'.9rem', fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", letterSpacing:'.05em', transition:'all .2s', boxShadow:`0 4px 16px rgba(13,34,24,.2)`, display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                {added ? '✓ Added to Cart' : '🛒 Add to Cart'}
              </button>
              <button onClick={() => { onAdd({ ...product, quantity: qty }); navigate('/checkout') }}
                style={{ flex:1, padding:'1rem', borderRadius:11, background:'white', color:C.g900, border:`2px solid ${C.g900}`, fontSize:'.9rem', fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", transition:'all .2s' }}
                onMouseEnter={e => { e.currentTarget.style.background=C.g900; e.currentTarget.style.color='white' }}
                onMouseLeave={e => { e.currentTarget.style.background='white'; e.currentTarget.style.color=C.g900 }}>
                Buy Now
              </button>
            </div>

            {/* Available Offers — carousel */}
            {(() => {
              const offers = [
                { icon:'🏷️', title:'Best-value offer', desc:`Instant savings worth ₹${mrp - product.price}` },
                { icon:'🚚', title:'Free shipping',     desc:'On orders above ₹499' },
                { icon:'💳', title:'Pay Later at checkout', desc:'Instant EMI | No credit card needed' },
              ]
              const o = offers[offerIdx]
              return (
                <div>
                  <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:'.72rem', fontWeight:700, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.5rem' }}>
                    <span>🪙</span> Available offers
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:8, background:C.g50, border:`1.5px solid ${C.border}`, borderRadius:10, padding:'.75rem 1rem' }}>
                    <button onClick={() => setOfferIdx(i => (i - 1 + offers.length) % offers.length)}
                      style={{ background:'none', border:'none', fontSize:'1.2rem', cursor:'pointer', color:C.g700, padding:'0 .15rem', lineHeight:1 }}>‹</button>
                    <div style={{ flex:1, display:'flex', alignItems:'center', gap:10 }}>
                      <span style={{ fontSize:'1.5rem', flexShrink:0 }}>{o.icon}</span>
                      <div>
                        <div style={{ fontSize:'.85rem', fontWeight:700, color:C.g900 }}>{o.title}</div>
                        <div style={{ fontSize:'.75rem', color:C.g700, marginTop:2 }}>{o.desc}</div>
                      </div>
                    </div>
                    <span style={{ fontSize:'.72rem', color:C.g700, fontWeight:600, whiteSpace:'nowrap' }}>{offerIdx + 1}/{offers.length}</span>
                    <button onClick={() => setOfferIdx(i => (i + 1) % offers.length)}
                      style={{ background:'none', border:'none', fontSize:'1.2rem', cursor:'pointer', color:C.g700, padding:'0 .15rem', lineHeight:1 }}>›</button>
                  </div>
                </div>
              )
            })()}

            {/* Check Delivery */}
            <div style={{ border:`1px solid ${C.border}`, borderRadius:10, padding:'.85rem 1rem' }}>
              <div style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.5rem' }}>Check Delivery</div>
              <div style={{ display:'flex', gap:'.5rem' }}>
                <input value={pincode} onChange={e => setPincode(e.target.value.replace(/\D/g,'').slice(0,6))} placeholder="Enter pincode"
                  style={{ flex:1, padding:'.6rem .85rem', border:`1.5px solid ${C.border}`, borderRadius:8, fontSize:'.85rem', outline:'none', fontFamily:"'DM Sans',sans-serif" }}
                  onKeyDown={e => e.key === 'Enter' && checkPincode()} />
                <button onClick={checkPincode} style={{ padding:'.6rem 1.1rem', background:C.g700, color:'white', border:'none', borderRadius:8, fontSize:'.82rem', fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Check</button>
              </div>
              {pincodeMsg && <div style={{ fontSize:'.78rem', marginTop:'.4rem', color: pincodeMsg.startsWith('✅') ? C.g600 : '#e53e3e' }}>{pincodeMsg}</div>}
            </div>

          </div>
        </div>

        {/* ── Full-width: remaining accordions ── */}
        <div className="pp-2col" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'0 4rem', borderTop:`1px solid ${C.border}`, paddingTop:'.5rem' }}>
          <div>
            <Accordion id="desc" title="Product Description">
              <p style={{ fontSize:'.9rem', color:'#374151', lineHeight:1.9, margin:0 }}>{product.desc || 'Dermatologist-recommended formulation for daily use. Clinically tested and proven effective.'}</p>
            </Accordion>
            <Accordion id="ingredients" title="Key Ingredients">
              {(() => {
                const ings = extractIngredients(product)
                return (
                  <div style={{ display:'flex', flexDirection:'column', gap:'.55rem' }}>
                    {ings.map((ing, i) => (
                      <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:12, background:ing.color, borderRadius:10, padding:'.75rem 1rem', border:'1px solid rgba(0,0,0,.04)' }}>
                        <span style={{ fontSize:'1.4rem', flexShrink:0, lineHeight:1 }}>{ing.emoji}</span>
                        <div>
                          <div style={{ fontSize:'.85rem', fontWeight:700, color:C.g900, marginBottom:2 }}>{ing.name}</div>
                          <div style={{ fontSize:'.77rem', color:'#4B5563', lineHeight:1.55 }}>{ing.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )
              })()}
            </Accordion>
            <Accordion id="howto" title="How to Use">
              <div style={{ display:'flex', flexDirection:'column', gap:'.85rem' }}>
                {[
                  { n:'01', text: product.cat==='Sunscreen' ? 'Apply evenly on exposed areas at least 20 minutes before sun exposure.' : 'Cleanse the area thoroughly before application.' },
                  { n:'02', text: product.cat==='Sunscreen' ? 'Reapply every 2–3 hours for continued protection.' : 'Apply the appropriate amount and gently massage in circular motions.' },
                  { n:'03', text: 'Use as directed by your dermatologist for best results. Consistent daily use is key.' },
                ].map(step => (
                  <div key={step.n} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                    <span style={{ width:26, height:26, borderRadius:7, background:C.g700, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.62rem', fontWeight:700, flexShrink:0, fontFamily:"'DM Sans',sans-serif" }}>{step.n}</span>
                    <p style={{ fontSize:'.87rem', color:'#374151', lineHeight:1.8, margin:0, paddingTop:3 }}>{step.text}</p>
                  </div>
                ))}
              </div>
            </Accordion>
          </div>
          <div>
            <Accordion id="benefits" title="Key Benefits">
              <div style={{ display:'flex', flexDirection:'column', gap:'.6rem' }}>
                {[
                  product.cat==='Sunscreen' && 'Protects against UVA, UVB, and IR rays',
                  product.cat==='Sunscreen' && 'Non-greasy, lightweight formula ideal for daily use',
                  product.cat==='Moisturizers' && 'Provides long-lasting deep hydration',
                  product.cat==='Moisturizers' && 'Strengthens the skin moisture barrier',
                  product.cat==='Face Wash' && 'Gently removes impurities without stripping skin',
                  product.cat==='Serums' && 'Penetrates deep for targeted treatment',
                  product.cat==='Hair Care' && 'Nourishes scalp and reduces hair fall',
                  'Dermatologist tested and recommended',
                  'Suitable for all Indian skin types',
                ].filter(Boolean).map((b,i) => (
                  <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:8, fontSize:'.87rem', color:'#374151' }}>
                    <span style={{ width:18, height:18, borderRadius:'50%', background:C.g700, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.58rem', fontWeight:700, flexShrink:0, marginTop:2 }}>✓</span>
                    {b}
                  </div>
                ))}
              </div>
            </Accordion>
            <Accordion id="info" title="Other Information">
              <div style={{ display:'flex', flexDirection:'column', gap:'.5rem', fontSize:'.85rem', color:'#374151' }}>
                {[['Country of Origin','India'],['Brand',product.brand],['Category',product.cat],['Manufacturer',`${product.brand} Pharmaceuticals`]].map(([k,v]) => (
                  <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'.4rem 0', borderBottom:`1px solid ${C.border}` }}>
                    <span style={{ color:C.muted }}>{k}</span><span style={{ fontWeight:500 }}>{v}</span>
                  </div>
                ))}
              </div>
            </Accordion>
            <Accordion id="faq" title="Frequently Asked Questions">
              <div style={{ display:'flex', flexDirection:'column', gap:'.75rem', fontSize:'.85rem' }}>
                {[
                  [`Is ${product.name} safe for daily use?`, 'Yes, this product is dermatologist-tested and suitable for daily use as directed.'],
                  ['How long before I see results?', 'Visible results typically appear within 4–6 weeks of consistent use.'],
                  ['Can I use this with other products?', 'Consult your dermatologist before combining with other active ingredients.'],
                ].map(([q,a]) => (
                  <div key={q}>
                    <div style={{ fontWeight:600, color:C.g900, marginBottom:'.25rem' }}>{q}</div>
                    <div style={{ color:C.muted, lineHeight:1.7 }}>{a}</div>
                  </div>
                ))}
              </div>
            </Accordion>
          </div>
        </div>


        {/* Reviews section */}
        {(() => {
          const hasReal = realReviews && realReviews.length > 0
          const displayReviews = hasReal ? realReviews.map(r => ({
            init: r.name.trim()[0].toUpperCase(),
            name: r.name,
            text: r.text,
            stars: r.rating
          })) : rv.reviews
          const avgDisplay  = hasReal ? (realReviews.reduce((a,r)=>a+r.rating,0)/realReviews.length).toFixed(1) : rv.avg
          const totalDisplay = hasReal ? realReviews.length : rv.total
          return (
            <div style={{ marginTop:'3rem', paddingTop:'2.5rem', borderTop:`1px solid ${C.border}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
                <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.5rem', color:C.g900, margin:0 }}>Customer Reviews</h2>
                <button onClick={() => setShowForm(f=>!f)}
                  style={{ fontSize:'.8rem', fontWeight:600, color:'white', background:C.g700, border:'none', borderRadius:8, padding:'.45rem 1rem', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  {showForm ? 'Cancel' : '+ Write a Review'}
                </button>
              </div>

              {/* Review submission form */}
              {showForm && (
                <div style={{ background:C.g50, border:`1px solid ${C.border}`, borderRadius:12, padding:'1.25rem', marginBottom:'1.5rem' }}>
                  <div className="pp-2col" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', marginBottom:'1rem' }}>
                    <div>
                      <label style={{ fontSize:'.78rem', fontWeight:600, color:C.g700, display:'block', marginBottom:4 }}>Your Name *</label>
                      <input value={formName} onChange={e=>setFormName(e.target.value)} placeholder="e.g. Priya S."
                        style={{ width:'100%', padding:'.55rem .75rem', borderRadius:8, border:`1px solid ${C.border}`, fontSize:'.85rem', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontSize:'.78rem', fontWeight:600, color:C.g700, display:'block', marginBottom:4 }}>Rating *</label>
                      <div style={{ display:'flex', gap:4, marginTop:6 }}>
                        {[1,2,3,4,5].map(n => (
                          <span key={n} onClick={()=>setFormRating(n)}
                            style={{ fontSize:'1.4rem', cursor:'pointer', color: n<=formRating ? '#F59E0B' : C.border }}>★</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom:'1rem' }}>
                    <label style={{ fontSize:'.78rem', fontWeight:600, color:C.g700, display:'block', marginBottom:4 }}>Your Review *</label>
                    <textarea value={formText} onChange={e=>setFormText(e.target.value)} placeholder="Share your experience with this product..."
                      rows={3} style={{ width:'100%', padding:'.55rem .75rem', borderRadius:8, border:`1px solid ${C.border}`, fontSize:'.85rem', fontFamily:"'DM Sans',sans-serif", resize:'vertical', boxSizing:'border-box' }} />
                  </div>
                  {formStatus && formStatus !== 'sending' && (
                    <p style={{ fontSize:'.8rem', color: formStatus==='done' ? '#059669' : '#dc2626', margin:'0 0 .75rem' }}>{formStatus==='done' ? 'Review submitted! It will appear after approval.' : formStatus}</p>
                  )}
                  <button onClick={submitReview} disabled={formStatus==='sending' || !formName.trim() || !formText.trim()}
                    style={{ background:C.g700, color:'white', border:'none', borderRadius:8, padding:'.55rem 1.25rem', fontSize:'.85rem', fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", opacity: (!formName.trim()||!formText.trim()) ? .5 : 1 }}>
                    {formStatus==='sending' ? 'Submitting...' : 'Submit Review'}
                  </button>
                </div>
              )}

              <div style={{ display:'flex', gap:'3rem', alignItems:'flex-start', flexWrap:'wrap' }}>
                <div style={{ textAlign:'center', flexShrink:0 }}>
                  <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:'3.5rem', color:C.g900, lineHeight:1 }}>{avgDisplay}</div>
                  <div style={{ color:'#F59E0B', fontSize:'1.2rem', marginTop:4 }}>★★★★★</div>
                  <div style={{ fontSize:'.78rem', color:C.muted, marginTop:4 }}>{totalDisplay} Reviews</div>
                </div>
                {!hasReal && (
                  <div style={{ flex:1, minWidth:200 }}>
                    {rv.dist.map(([stars,pct]) => (
                      <div key={stars} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:'.5rem' }}>
                        <span style={{ fontSize:'.78rem', color:C.muted, width:12, textAlign:'right' }}>{stars}</span>
                        <span style={{ color:'#F59E0B', fontSize:'.75rem' }}>★</span>
                        <div style={{ flex:1, height:8, background:C.border, borderRadius:999, overflow:'hidden' }}>
                          <div style={{ width:pct, height:'100%', background:'#F59E0B', borderRadius:999 }} />
                        </div>
                        <span style={{ fontSize:'.75rem', color:C.muted, width:32 }}>{pct}</span>
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ flex:2, minWidth:240 }}>
                  {displayReviews.map((r,i) => (
                    <div key={i} style={{ marginBottom:'1.25rem', paddingBottom:'1.25rem', borderBottom: i<displayReviews.length-1 ? `1px solid ${C.border}` : 'none' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:'.5rem' }}>
                        <div style={{ width:32, height:32, borderRadius:'50%', background:C.g700, color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.85rem', fontWeight:600 }}>{r.init}</div>
                        <div>
                          <div style={{ fontSize:'.82rem', fontWeight:600, color:C.g900 }}>{r.name}</div>
                          <div style={{ color:'#F59E0B', fontSize:'.72rem' }}>{'★'.repeat(r.stars)}</div>
                        </div>
                      </div>
                      <p style={{ fontSize:'.83rem', color:C.muted, lineHeight:1.7, margin:0 }}>{r.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        })()}


        {/* Related products */}
        {related.length > 0 && (
          <div style={{ marginTop:'3rem', paddingTop:'2.5rem', borderTop:`1px solid ${C.border}` }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
              <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.5rem', color:C.g900, margin:0 }}>More from {product.brand}</h2>
              <button onClick={() => navigate('/shop', { state:{ brandFilter:product.brand } })}
                style={{ fontSize:'.8rem', color:C.g700, background:'none', border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif", borderBottom:`1.5px solid ${C.g400}`, paddingBottom:2 }}>
                View all →
              </button>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(190px,1fr))', gap:'1.25rem' }}>
              {related.map(p => (
                <div key={p.id} onClick={() => navigate(`/product/${p.id}`)}
                  style={{ background:'white', border:`1px solid ${C.border}`, borderRadius:12, overflow:'hidden', cursor:'pointer', transition:'all .25s' }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow='0 6px 20px rgba(13,34,24,.1)'; e.currentTarget.style.transform='translateY(-3px)' }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none' }}>
                  <div style={{ height:145, background:'white', display:'flex', alignItems:'center', justifyContent:'center', padding:'.75rem' }}>
                    {p.imgs?.[0] ? <img src={p.imgs[0]} alt={p.name} style={{ maxHeight:125, maxWidth:'100%', objectFit:'contain', mixBlendMode:'multiply' }} /> : <span style={{ fontSize:'2rem', opacity:.1 }}>🧴</span>}
                  </div>
                  <div style={{ padding:'.75rem' }}>
                    <div style={{ fontSize:'.78rem', fontWeight:600, color:C.g900, lineHeight:1.3, marginBottom:'.35rem' }}>{p.name}</div>
                    <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1rem', color:C.g700 }}>₹{p.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
